module.exports = __webpack_public_path__ + "static/media/Restraint Bias - hugo-aitken-PqYvDBwpXpU-unsplash.758f6011.jpg";